import { t } from "@bezbolisno/i18n";
import { Brand } from "@bezbolisno/ui/brand";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { signOut } from "../lib/auth";
import { keys } from "../lib/keys";
import { sessionQuery } from "../lib/session";

export const Route = createFileRoute("/no-access")({
  beforeLoad: async ({ context }) => {
    const session = await context.queryClient.ensureQueryData(sessionQuery);
    if (!session) throw redirect({ to: "/login" });
    if (session.role !== "none") throw redirect({ to: "/" });
    return { session };
  },
  component: NoAccessPage,
});

function NoAccessPage() {
  const { session } = Route.useRouteContext();
  const { queryClient } = Route.useRouteContext();
  async function logout() {
    await signOut();
    queryClient.setQueryData(keys.session, null);
    location.assign("/login");
  }
  return (
    <main className="min-h-dvh grid place-items-center p-6">
      <section
        className="card max-w-md w-full p-8 text-center space-y-4"
        aria-labelledby="no-access-title"
      >
        <div className="flex justify-center">
          <Brand />
        </div>
        <h1 id="no-access-title" className="text-xl font-semibold">
          {t.auth.noRoleTitle}
        </h1>
        <p className="text-sm text-[color:var(--muted)]">{t.auth.noRoleBody}</p>
        <p className="text-xs text-[color:var(--muted)]">{session.email}</p>
        {/* An anchor (the Next page had one too): sign out, then land on /login. */}
        <a
          href="/login"
          className="btn btn--primary inline-flex"
          onClick={(e) => {
            e.preventDefault();
            void logout();
          }}
        >
          {t.auth.signOut}
        </a>
      </section>
    </main>
  );
}
